import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AppRoutes, GamesRoutes, MODAL_TOKEN, ModalProvider } from '@core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-push-lineups',
  templateUrl: './push-lineups.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushLineupsComponent {
  @Input() gameId!: string;

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly router: Router = inject(Router);

  handleAction(): void {
    this.modalProvider.dismissAllStoredModals();
    this.router.navigateByUrl(`${AppRoutes.GAMES}/${GamesRoutes.LINEUPS}/${this.gameId}`);
  }

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
